import statisticsReducers from '../statisticsReducer';

export default statisticsReducers({
    apiDataFieldName: 'tracks',
    statisticsActionName: 'EVENTS',
});
